import AppSettings from "Settings/AppSettings";
import ServiceWrapper from "Services/ServiceWrapper";
import AuthManager from "Common/AuthManager";
import { TPaginationParams } from "Pages/GMS/Performance/analytics";
import { CalculateTestDurationPayload } from "../types/ab";

const apiBaseUrl = AppSettings.GMS_BACKEND_API_URL;

export const getABTests = async (
  industryId: string,
  channelId: string,
  paginationParams: TPaginationParams
) => {
  try {
    const endPoint = `ab_testing/ab_tests/${industryId}/${channelId}?page=${paginationParams.pageNumber}&limit=${paginationParams.pageSize}`;
    const response = await ServiceWrapper.doGet(
      apiBaseUrl + endPoint,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.error("uploadStatus ~ error:", error);
    return null;
  }
};

export const getABTest = async (testId: string) => {
  try {
    const endPoint = `ab_testing/${testId}`;
    const response = await ServiceWrapper.doGet(
      apiBaseUrl + endPoint,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.error("uploadStatus ~ error:", error);
    return null;
  }
};

export const deleteABTest = async (testId: string) => {
  const response = await ServiceWrapper.doDelete(
    apiBaseUrl + `ab_testing/delete/${testId}`,
    null,
    null,
    AuthManager.getGmsToken()
  );
  try {
    return response?.data;
  } catch (e) {
    console.log(e, "error");
    return null;
  }
};

export const createAbTest = async (
  industryId: string,
  channelId: string,
  testName: string
) => {
  try {
    const payload = {
      name: testName,
      industry: industryId,
      channel: channelId
    };
    const response = await ServiceWrapper.doPost(
      apiBaseUrl + "ab_testing/create",
      payload,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.log("createAbTest ~ error:", error);
    return null;
  }
};

export const updateAbTest = async (payload: any) => {
  try {
    const response = await ServiceWrapper.doPut(
      apiBaseUrl + "ab_testing/update",
      payload,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.log("updateAbTest ~ error:", error);
    return null;
  }
};

export const getAllApplets = async (channelId: string) => {
  try {
    const response = await ServiceWrapper.doGet(
      apiBaseUrl + `recommender/applet/list/${channelId}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (e) {
    console.log(e, "error");
    return null;
  }
};

export const getModelsBasedOnChannelKey = async (channelKey: string) => {
  try {
    const response = await ServiceWrapper.doGet(
      apiBaseUrl + `ab_testing/models/${channelKey}?status=promoted`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.log("getModelsBasedOnChannelKey ~ error:", error);
    return null;
  }
};

export const calculateABTestDuration = async (testId: string, payload: CalculateTestDurationPayload) => {
  try {
    const endPoint = `ab_testing/calculate_test_duration/${testId}`
    const response = await ServiceWrapper.doPost(
      apiBaseUrl + endPoint,
      payload,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.error("calculateABTestDuration ~ error:", error);
    return null;
  }
}

export const runABTest = async (testId: string) => {
  try {
    const endPoint = `ab_testing/run_test/${testId}`;
    const response = await ServiceWrapper.doPost(
      apiBaseUrl + endPoint,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.error("runABTest ~ error:", error);
    return null;
  }
};

export const getABAnalytics = async (testId: string) => {
  try {
    const endPoint = `ab_testing/analytics/dashboard/graphs/${testId}`;
    const response = await ServiceWrapper.doGet(
      apiBaseUrl + endPoint,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.error("uploadStatus ~ error:", error);
    return null;
  }
};

export const getTrafficAllocation = async (testId: string) => {
  try {
    const endPoint = `ab_testing/analytics/traffic_allocation/${testId}`;
    const response = await ServiceWrapper.doGet(
      apiBaseUrl + endPoint,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.error("getTrafficAllocation ~ error:", error);
    return null;
  }
};

export const computeABTestResult = async (testId: string) => {
  try {
    const endPoint = `ab_testing/compute_result/${testId}`;
    const response = await ServiceWrapper.doPost(
      apiBaseUrl + endPoint,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.error("runABTest ~ error:", error);
    return null;
  }
};

export const finishABTest = async (testId: string, modelId: string) => {
  try {
    const endPoint = `ab_testing/finish_test/${testId}/${modelId}`;
    const response = await ServiceWrapper.doPost(
      apiBaseUrl + endPoint,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.error("runABTest ~ error:", error);
    return null;
  }
};

export const promoteModel = async (testId: string, modelId: string) => {
  try {
    const endPoint = `ab_testing/promote/${testId}/${modelId}`;
    const response = await ServiceWrapper.doPost(
      apiBaseUrl + endPoint,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.error("runABTest ~ error:", error);
    return null;
  }
};

export const getLiveApplets = async (channelId: string) => {
  try {
    const endPoint = `recommender/applet/live_list/channel/${channelId}`;
    const response = await ServiceWrapper.doGet(
      apiBaseUrl + endPoint,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response?.data;
  } catch (error) {
    console.error("Get Live Applets ~ error:", error);
    return null;
  }
};